import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
/**
 * An nile-menu element.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('nile-menu')
export class NileMenu extends LitElement {
  static override styles = css`
    :host {
      display: block;
      width: 100%;
    }
    .nds-menu {
      display: flex;
      padding: 6px 6px;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 12px;
      align-items: center;
      text-decoration: none;
    }

    .nds-menu:hover {
      background: rgba(0, 94, 166, 0.1);
    }
    .nds-menu__link {
      font-family: var(--nile-font-family-sans-serif);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0.2px;
      color: #131415;
      text-decoration: none;
      margin-left: 12px;
    }
    .nds-menu--active {
      background: rgba(0, 94, 166, 0.1);
    }

    .nds-menu__icon {
      margin-bottom: 0;
      height: 14px;
    }

    .nds-menu--short {
      width: auto;
      /* min-width: 30px; */
    }
    .nds-menu--short > .nds-menu__link {
      display:none;
    }
  `;

  /**
   * Button Lab
   */
  @property()
  name = 'Heading 1';

  /**
   * Button Lab
   */
  @property()
  icon: string = "";

  /**
   * Button Lab
   */
  @property()
  isActive: boolean = false;

  /**
   * Displays shorter version
   */
  @property()
  short: boolean = false;


  get buttonClassMap() {
    return {
      'nds-menu--active': this.isActive,
      'nds-menu--short': this.short
    };
  }

  /**
   * Button Lab
   */
  @property()
  href = "/";

  override render() {
    const { name, icon, href } = this;
    const hrefPath = `/${href}`;
    return html`
      <a class="nds-menu ${classMap(this.buttonClassMap)}">
        <span class="nds-menu__icon">
          <nile-icon name="${this.icon}" size="14" color="#000"></nile-icon>
        </span>
        <span class="nds-menu__link">${this.name}</span>
      </a>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nile-menu': NileMenu;
  }
}
